import { render, staticRenderFns } from "./cadrecibos.vue?vue&type=template&id=55a02b66&"
import script from "./cadrecibos.vue?vue&type=script&lang=js&"
export * from "./cadrecibos.vue?vue&type=script&lang=js&"
import style0 from "./cadrecibos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports